import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response && err.response.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const { data } = await axios.post(`${BASE_URL}/admin/refresh-token`, { refreshToken });
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(original);
      } catch (_err) {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  register: (d) => api.post('/admin/register', d),
  login: (d) => api.post('/admin/login', d),
  logout: () => api.post('/admin/logout'),
  profile: () => api.get('/admin/profile'),
  refreshToken: (d) => api.post('/admin/refresh-token', d),
};

export const apiKeysApi = {
  list: () => api.get('/api-keys'),
  get: (id) => api.get(`/api-keys/${id}`),
  create: (d) => api.post('/api-keys', d),
  update: (id, d) => api.put(`/api-keys/${id}`, d),
  delete: (id) => api.delete(`/api-keys/${id}`),
  regenerate: (id) => api.post(`/api-keys/${id}/regenerate`),
  usage: (id) => api.get(`/api-keys/${id}/usage`),
};

export const configApi = {
  get: () => api.get('/config'),
  update: (d) => api.put('/config/update', d),
  reset: () => api.post('/config/reset'),
  validate: (d) => api.post('/config/validate', d),
};

export const dashboardApi = {
  summary: () => api.get('/dashboard/summary'),
  logs: (params) => api.get('/dashboard/logs', { params }),
  errorLogs: (params) => api.get('/dashboard/error-logs', { params }),
  messageStats: (params) => api.get('/dashboard/message-stats', { params }),
  systemHealth: () => api.get('/dashboard/system-health'),
};

export const messagesApi = {
  send: (d) => api.post('/message/admin/send', d),
  bulkSend: (d) => api.post('/message/admin/bulk-send', d),
  logs: (params) => api.get('/message/admin/logs', { params }),
  stats: (params) => api.get('/message/admin/stats', { params }),
  queueStatus: () => api.get('/message/admin/queue/status'),
  clearLogs: (d) => api.delete('/message/admin/logs', { data: d }),
};

export const whatsappApi = {
  status: () => api.get('/whatsapp/status'),
  connect: () => api.post('/whatsapp/connect'),
  disconnect: () => api.post('/whatsapp/disconnect'),
  testMessage: () => api.post('/whatsapp/test-message'),
  deviceInfo: () => api.get('/whatsapp/device-info'),
  history: (params) => api.get('/whatsapp/history', { params }),
  restart: () => api.post('/whatsapp/restart'),
};

export default api;
